export const applyMaskToTime = (time: string) => time.replace(/(\d{2})(\d{2})/, '$1:$2');
